
/* eslint-disable */
import React from 'react';
import "contents/assets/scss/page/member.scss";
function NewPw() {
  return (
    <main className='com_member p_newPw'>
      <div className='box'>
        <h2 className='title'>비밀번호 재설정</h2>
        <p className='txt'>보안을 위해 비밀번호 재설정이 필요합니다.</p>
        <ul className='com_input_sec'>
          <li className='tit_field'>새로운 비밀번호를 입력해 주세요.</li>
          <li className='input_field'>
            <input type='password' className="input" placeholder='영문, 숫자, 특수문자 포함 8~16 자리'/>
            <span className="error_txt">* 보안에 취약한 비밀번호 입니다.</span>
          </li>
          <li className='tit_field'>비밀번호를 다시 한번 입력해 주세요.</li>
          <li className='input_field'>
            <input type='password' className="input" placeholder='영문, 숫자, 특수문자 포함 8~16 자리'/>
            <span className="error_txt">* 비밀번호가 일치하지 않습니다.</span>
          </li>
        </ul>
        <section className='com_btn_wrap'>
          <button className='com_btn orange m bold'>비밀번호 변경</button>
        </section>
      </div>
    </main>
  );
}

export default NewPw;
